<template>
  <div class="table ">
    <el-tabs v-model="activeName">
      <el-tab-pane label="Tất cả" name="all">
        <NotData v-if="historyList.length === 0"></NotData>
        <div v-else class="result">
          <div v-for="(item,index) in historyList"  class="item" :key="item?.id">
            <HandleResult v-if="isHandleResultType(item.type)" :history="item"></HandleResult>
            <MeasurementResults v-else :history="item"></MeasurementResults>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Kết quả xử lý" name="handle">
        <NotData v-if="processingResultList.length === 0"></NotData>
        <div v-else class="result">
          <div v-for="(item,index) in processingResultList"  class="item" :key="item?.id">
            <HandleResult  :history="item"></HandleResult>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Kết quả đo lường" name="measurement">
        <NotData v-if="measurementResultList.length === 0"></NotData>
        <div v-else class="result">
          <div v-for="(item,index) in measurementResultList"  class="item" :key="item?.id">
            <MeasurementResults  :history="item"></MeasurementResults>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import NotData from "./component/NotData.vue";
import {
  MEASUREMENT_RESULT_SYSTEM,
  PROCESSING_RESULT_NO_MEASUREMENT,
  PROCESSING_RESULT_WITH_MEASUREMENT
} from "../../../../../core/option/leaderRadarOption";
import HandleResult from "./component/HandleResult.vue";
import MeasurementResults from "./component/MeasurementResults.vue";

export default {
  name: "HandleHistory",
  components: {MeasurementResults, HandleResult, NotData},
  props: {
    historyList:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeName: 'all',
      handleList: [],
    }
  },
  mounted() {

  },
  methods: {
    isHandleResultType(type){
      return [PROCESSING_RESULT_WITH_MEASUREMENT,PROCESSING_RESULT_NO_MEASUREMENT].includes(type)
    }

  },
  computed:{
    processingResultList(){
      return this.historyList.filter(item => this.isHandleResultType(item.type))
    },
    measurementResultList(){
      return this.historyList.filter(item => item.type === MEASUREMENT_RESULT_SYSTEM)
    }

  }
}
</script>
<style scoped>
.table {
  width: 100%;
  background-color: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #D6D5D5;
  padding: 15px;

}
.result{

  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction:column;
  gap: 20px;
}

</style>